module.exports = __webpack_public_path__ + "img/instagram-logo.8593d66d.svg";